// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N900, N20, N0, B100 } from '@atlaskit/theme/colors';
import { fontFallback } from '@atlaskit/theme/typography';
import { Link } from '@atlassian/search-dialog';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var CenteredAdvancedSearchGroup = styled.div({
  display: 'flex',
  alignItems: 'center'
});
var outlineWidth = 2;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var StyledAdvancedSearch = styled(Link)(function (props) {
  return {
    alignItems: 'center',
    color: "var(--ds-text, ".concat(N900, ")"),
    cursor: 'pointer',
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    padding: "var(--ds-space-075, 6px)".concat(" ", 2 * 8 - outlineWidth, "px"),
    border: "".concat(outlineWidth, "px solid transparent"),
    '&:hover': {
      color: "var(--ds-text, ".concat(N900, ")"),
      backgroundColor: "var(--ds-background-neutral, ".concat(N20, ")"),
      textDecoration: 'none'
    },
    '&:visited': {
      color: "var(--ds-text, ".concat(N900, ")")
    },
    '&:focus': {
      outline: 'none',
      border: "".concat(outlineWidth, "px solid ", "var(--ds-border-focused, ".concat(B100, ")"))
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: props.isKeyboardHighlighted ? "var(--ds-background-neutral, ".concat(N20, ")") : "var(--ds-background-neutral-subtle, ".concat(N0, ")")
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AdvancedSearchContent = styled.span({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  font: "var(--ds-font-body, ".concat(fontFallback.body.medium, ")"),
  paddingLeft: "var(--ds-space-200, 16px)",
  display: 'flex',
  alignItems: 'center'
});